// The styles registered in this file are applied in the shadow dom of vaadin-grid
// All styles should target the :host element together with the 'for-gz-data-table' attribute, e.g. :host([for-gz-data-table]),
// to ensure that they do not affect other vaadin-grid instances in the application

:host([for-gz-data-table]) {
  background-color: var(--row-background-color);

  tbody {
    z-index: 1; // ensure that dropdowns (from tbody) are displayed above the footer
  }

  tfoot {
    z-index: 0 !important;
  }

  table thead#header [part=row]:hover [part~=cell][first-column][frozen] {
   background-color: transparent !important;
  }

  &::part(cell) {
    background: var(--row-background-color);
    font-size: var(--body-size-medium);
    font-family: var(--font-family-secondary);
    border-top: none;
    border-bottom: 1px solid var(--row-border-color) !important; // overrides vaadin-grid no-border theme styles
    min-height: calc(var(--spacer) * 4);
    max-width: var(--column-max-width);
    color: var(--body-text-arrows-400);
  }

  &::part(footer-cell) {
    background: transparent;
    height: var(--footer-height);
    border-bottom: var(--footer-border-bottom) !important; // overrides vaadin-grid no-border theme styles
  }

  & [part~='cell'][last-frozen] {
    overflow: unset;
  }

  & [part~='row'].row-edit-mode {
    z-index: 2;
  }

  & [part~='row'] [part~='cell'].selected-cell,
  & [part~='row']:hover [part~='cell'].selected-cell {
    background: var(--blue-layout-051-selected) !important;
  }
}

:host([for-gz-data-table][disabled]) {
  & [part~='cell'] ::slotted(vaadin-grid-cell-content) {
    opacity: 0.34; // placing this here prevents opacity from affecting the borders
  }
}
// here we add the styles for the left overflow to avoid overlapping issues with left frozen columns
:host([for-gz-data-table][overflow~='left']) {
  & table thead#header [part=row]:hover [part~=cell][first-column][frozen] {
    background-color: var(--white-layout-301-level-0-elevation) !important;
  }
  & [part~='cell'][first-column][frozen] {
    background-color: var(--white-layout-301-level-0-elevation) !important;
    &:hover {
      background-color: var(--white-layout-301-level-0-elevation) !important;
    }
  }
  & [part~='cell'][last-frozen]:not([part~='footer-cell']) {
    border-right-color: var(--row-border-color) !important; // override default vaadin-grid styles
    background-color: var(--white-layout-301-level-0-elevation) !important;
  }

  [part~='footer-cell'] {
    border-right-color: transparent !important; // override default vaadin-grid styles
  }
}

:host([for-gz-data-table][part='row-reordering-allowed']) #items {
  & [part~='row'][role~='row'],
  & [part~='cell'] ::slotted(vaadin-grid-cell-content) {
    cursor: grab;
  }

  & [part~='row'][dragover='below'] [part~='cell']::after,
  & [part~='row'][dragover='above'] [part~='cell']::after {
    background: var(--blue-layout-300-active);
  }
}

:host([for-gz-data-table]) {
  // here we keep overrides for vaadin-grid styles set in gz-grid-view via 'my-grid-styles' dom module
  & [part~='cell'][first-column] {
    padding-left: 0 !important;
  }

  [part~='row']:hover > [part~='body-cell'] {
    background-color: var(--row-background-color) !important;
  }
}
